<!-- first -->
@if (step() === 1) {
  <portal-step-1-svg />
}
<!-- second -->
@if (step() === 2) {
  <portal-step-2-svg />
}
<!-- third -->
@if (step() === 3) {
  <portal-step-3-svg />
}
